import { render, staticRenderFns } from "./TooltipButton.vue?vue&type=template&id=1cd31300&scoped=true&"
import script from "./TooltipButton.vue?vue&type=script&lang=js&"
export * from "./TooltipButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cd31300",
  null
  
)

export default component.exports